import { Component, OnInit } from '@angular/core';
import { IEntityListComponentMembers, IEntityListDynamicCellComponentGeneric } from '@mt-ng2/entity-list-module';
import { IRegistrationRequest } from '../../model/interfaces/registration-request';
import { CarrierService } from '../../carriers/services/carrier.service';
import { RegistrationRequestService } from '../registration-request.service';
import { NotificationsService } from '@mt-ng2/notifications-module';
import { ModalService } from '@mt-ng2/modal-module';
import { ICarrier } from '../../model/interfaces/carrier';

@Component({
    template: `
        <div (click)="$event.stopPropagation()">
            <select 
                class="form-control"
                style="min-width: 200px; font-size: 14px; height: 38px;"
                [value]="entity.CarrierId || 0"
                (change)="onCarrierChange($event)"
                [disabled]="entity.CustomerId > 0">
                <option value="0">-- Select Carrier --</option>
                <option *ngIf="shouldShowCurrentCarrier()" 
                        [value]="entity.CarrierId" 
                        [selected]="true">
                    {{entity.Carrier?.Name || 'Current Carrier'}}
                </option>
                <option *ngFor="let carrier of carriers" [value]="carrier.Id" [selected]="carrier.Id === entity.CarrierId">
                    {{carrier.Name}}
                </option>
            </select>
        </div>
    `,
    standalone: false
})
export class RegistrationRequestCarrierCellComponent implements IEntityListDynamicCellComponentGeneric<IRegistrationRequest>, OnInit {
    entity: IRegistrationRequest;
    entityListComponentMembers: IEntityListComponentMembers;
    carriers: ICarrier[] = [];

    constructor(
        private carrierService: CarrierService,
        private registrationRequestService: RegistrationRequestService,
        private notificationsService: NotificationsService,
        private modalService: ModalService
    ) {}

    ngOnInit(): void {
        this.loadCarriers();
    }

    shouldShowCurrentCarrier(): boolean {
        return this.entity.CarrierId > 0 && !this.carriers.find(c => c.Id === this.entity.CarrierId);
    }

    loadCarriers(): void {
        if (this.carrierService.getActive) {
            this.carrierService.getActive().subscribe({
                next: (carriers) => {
                    this.carriers = carriers || [];
                },
                error: () => {
                    this.carriers = [];
                }
            });
        }
    }

    onCarrierChange(event: Event): void {
        const target = event.target as HTMLSelectElement;
        const carrierId = parseInt(target.value);
        const carrierName = carrierId > 0 ? this.carriers.find(c => c.Id === carrierId)?.Name : 'None';
        
        this.modalService.showModal({
            confirmButtonText: 'Yes, Assign Carrier',
            showCancelButton: true,
            cancelButtonText: 'No, Cancel',
            text: `Are you sure you want to assign carrier "${carrierName}" to ${this.entity.FirstName} ${this.entity.LastName}?`,
            title: 'Confirm Carrier Assignment',
            icon: 'warning',
        }).subscribe((result) => {
            if (result.isConfirmed) {
               
                const updatedRequest = { ...this.entity };
                updatedRequest.CarrierId = carrierId === 0 ? null : carrierId;
                updatedRequest.CustomerId = null; 

                this.registrationRequestService.update(updatedRequest).subscribe({
                    next: () => {
                        this.entity.CarrierId = updatedRequest.CarrierId;
                        this.entity.CustomerId = null;
                        this.entity.Carrier = carrierId > 0 ? this.carriers.find(c => c.Id === carrierId) : null;
                        this.entity.Customer = null;
                        this.notificationsService.success('Carrier assigned successfully');
                        location.reload();
                    },
                    error: () => {
                        this.notificationsService.error('Failed to assign carrier');
                        target.value = (this.entity.CarrierId || 0).toString(); 
                    }
                });
            } else {
                target.value = (this.entity.CarrierId || 0).toString();
            }
        });
    }
}
